import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./routing-lp/routing-lp.routes').then(m => m.routingLpRoutes)
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./routing-login/routing-login.routes').then(m => m.routingLoginRoutes)
      },
      {
        path: 'invite',
        loadChildren: () =>
          import('./routing-invite/routing-invite.routes').then(m => m.routingInviteRoutes)
      },
      {
        path: 'member',
        loadChildren: () =>
          import('./routing-member-area/routing-member-area.routes').then(m => m.routingMemberAreaRoutes)
      },
      {
        path: 'password-reset',
        loadChildren: () =>
          import('./routing-password-reset/routing-password-reset.routes').then(
            m => m.routingPasswordResetRoutes
          )
      },
      {
        path: 'page',
        loadChildren: () =>
          import('./routing-static/routing-static.routes').then(m => m.routingStaticRoutes)
      },
      {
        path: 'application',
        loadChildren: () =>
          import('./routing-application-form/routing-application-form.routes').then(
            m => m.routingApplicationFormRoutes
          )
      },
      {
        path: '404',
        component: NotFoundComponent
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];
